import api from "services/api";

interface Chart {
  boardDesc: string;
  boardName: string;
  categoryId: number;
  dataSource: string;
  htmlText: string;
  htmlTextMobile: string;
  id: number;
  thumbnailUrl: string;
  unitName: string;
  updateDate: string;
  url: string;
  viewsCount: number;
}

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    foreCharts: build.query<Chart[], number | void>({
      query: (categoryId) => ({
        url: "/charts",
        params: { categoryId: categoryId ?? undefined },
      }),
    }),
    foreRecommendCharts: build.query<Chart[], number | void>({
      query: (top) => ({
        url: "/charts/recommend",
        params: { top: top ?? undefined },
      }),
    }),
    foreChart: build.query<Chart, string>({
      query: (id) => `/charts/${id}`,
    }),
  }),
  overrideExisting: false,
});

export const {
  useForeChartsQuery,
  useForeRecommendChartsQuery,
  useForeChartQuery,
} = extendedApi;
